// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"118":"f454724c","584":"ea809baa","595":"09ee5aca","617":"49a03919","695":"4f249552","891":"cbe77bbf"}[chunkId] + ".js";
};